<template>
  <button
    :type="type"
    :disabled="isDisabled"
    :aria-busy="loading ? 'true' : 'false'"
    @click="handleClick"
  >
    <span v-if="loading" class="app-loading-button-content">
      <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      <span v-if="loadingLabel">{{ loadingLabel }}</span>
    </span>
    <span v-else class="app-loading-button-content">
      <slot>{{ label }}</slot>
    </span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'AppLoadingButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    loadingLabel: {
      type: String,
      default: 'Traitement...',
    },
  },
  emits: ['click'],
  computed: {
    isDisabled(): boolean {
      return this.disabled || this.loading;
    },
  },
  methods: {
    handleClick(event: MouseEvent): void {
      if (this.isDisabled) {
        event.preventDefault();
        event.stopPropagation();

        return;
      }

      this.$emit('click', event);
    },
  },
});
</script>

<style scoped>
.app-loading-button-content {
  align-items: center;
  display: inline-flex;
  gap: 0.35rem;
  justify-content: center;
  white-space: nowrap;
}
</style>
